"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var firebase = _interopRequireWildcard(require("firebase/app"));

var _Firebase = require("AppCore/Libs/Firebase");

var _models = require("@knxlab/models");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var schema = {
  type: "object",
  properties: {
    id: {
      type: "string"
    },
    email: {
      type: "string"
    },
    displayName: {
      type: "string"
    },
    centreId: {
      type: "string"
    },
    isActive: {
      type: 'boolean'
    },
    isAdmin: {
      type: 'boolean'
    },
    isSuperAdmin: {
      type: 'boolean'
    }
  },
  required: ["email"]
};
var NAME = "IzziStockUser";

var User = /*#__PURE__*/function (_AbstractObject) {
  _inherits(User, _AbstractObject);

  var _super = _createSuper(User);

  function User() {
    var _this;

    _classCallCheck(this, User);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "id", void 0);

    _defineProperty(_assertThisInitialized(_this), "email", void 0);

    _defineProperty(_assertThisInitialized(_this), "displayName", void 0);

    _defineProperty(_assertThisInitialized(_this), "centreId", void 0);

    _defineProperty(_assertThisInitialized(_this), "isActive", true);

    _defineProperty(_assertThisInitialized(_this), "isSuperAdmin", void 0);

    _defineProperty(_assertThisInitialized(_this), "isAdmin", void 0);

    _defineProperty(_assertThisInitialized(_this), "isUp", void 0);

    _defineProperty(_assertThisInitialized(_this), "hasPermission", function (permission) {
      if (_this.isSuperAdmin) {
        return true;
      } // Only super admin can administrate centres


      if (permission === 'centreee' || permission === 'centres') {
        return false;
      }

      if (_this.isAdmin) {
        return true;
      }

      return false;
    });

    return _this;
  }

  _createClass(User, [{
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$export, id, email, displayName, userData, data, createUser, result, _result$data, createdUserId, error;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.validate();
                _this$export = this["export"](), id = _this$export.id, email = _this$export.email, displayName = _this$export.displayName, userData = _objectWithoutProperties(_this$export, ["id", "email", "displayName"]);
                data = {
                  email: email,
                  displayName: displayName
                };

                if (id) {
                  _context.next = 14;
                  break;
                }

                createUser = (0, _Firebase.firebaseFunctions)().httpsCallable('users-create');
                _context.next = 7;
                return createUser(_objectSpread(_objectSpread({}, data), {}, {
                  userData: userData
                }));

              case 7:
                result = _context.sent;
                _result$data = result.data, createdUserId = _result$data.id, error = _result$data.error;

                if (!error) {
                  _context.next = 11;
                  break;
                }

                throw error;

              case 11:
                this.id = createdUserId;
                _context.next = 16;
                break;

              case 14:
                _context.next = 16;
                return firebase.firestore().collection("users").doc(id).set(_objectSpread(_objectSpread({}, userData), {}, {
                  displayName: displayName
                }));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "getName",
    value: function getName() {
      return NAME;
    }
  }], [{
    key: "getAll",
    value: function () {
      var _getAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var getListUsers, users;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getListUsers = (0, _Firebase.firebaseFunctions)().httpsCallable('users-list');
                _context2.next = 3;
                return getListUsers();

              case 3:
                users = _context2.sent;
                return _context2.abrupt("return", {
                  data: (users.data || []).map(function (doc) {
                    var user = new User();

                    var data = _objectSpread({
                      id: doc.uid,
                      displayName: doc.displayName,
                      email: doc.email
                    }, doc.data);

                    user.setData(data);
                    user.id = doc.uid;
                    return user;
                  })
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getAll() {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getAllFromCentre",
    value: function () {
      var _getAllFromCentre = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(centreId) {
        var getListUsers, users;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                getListUsers = (0, _Firebase.firebaseFunctions)().httpsCallable('users-listincentre');
                _context3.next = 3;
                return getListUsers({
                  centreId: centreId
                });

              case 3:
                users = _context3.sent;
                return _context3.abrupt("return", {
                  data: (users.data || []).map(function (doc) {
                    var user = new User();

                    var data = _objectSpread({
                      id: doc.uid,
                      displayName: doc.displayName,
                      email: doc.email
                    }, doc.data);

                    user.setData(data);
                    user.id = doc.uid;
                    return user;
                  })
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getAllFromCentre(_x) {
        return _getAllFromCentre.apply(this, arguments);
      }

      return getAllFromCentre;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref) {
        var id, getUser, userData, doc, user;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = _ref.id;
                getUser = (0, _Firebase.firebaseFunctions)().httpsCallable('users-get');
                _context4.next = 4;
                return getUser({
                  uid: id
                });

              case 4:
                userData = _context4.sent;
                console.log("GET USER ", userData);

                if (userData.data) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return", null);

              case 8:
                doc = userData.data;
                user = new User();
                user.setData(_objectSpread({
                  id: doc.uid,
                  displayName: doc.displayName,
                  email: doc.email
                }, doc.data));
                return _context4.abrupt("return", user);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function get(_x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }]);

  return User;
}(_models.AbstractObject);

exports["default"] = User;
User.register({
  name: NAME,
  schema: schema,
  __class: User
});